import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as Sentry from '@sentry/browser';
import App from './App';

try {
  if (window.runConfig.REACT_APP_SENTRY_DSN) {
    Sentry.init({ dsn: window.runConfig.REACT_APP_SENTRY_DSN });
  } else {
    console.log('No sentry DSN found');
  }
} catch (e) {
  // console.log('Sentry problem', e);
}

ReactDOM.render(<App />, document.getElementById('root'));
